<template>
  <form class="Slide" @submit.prevent :data-testing-target="isCurrentSlide && 'activeSlide'">
    <h3 class="title">
      <span v-if="isStartingSlide">{{ localeStrings.greeting }}<br></span>
      {{ title }}
    </h3>
    <div class="body">
      <slot></slot>
    </div>
    <div class="buttonRow">
      <BackButton v-if="!isStartingSlide"
        type="button"
        @click="previousSlide"
        class="previousButton"
        :disabled="!isCurrentSlide"
      >
        {{ localeStrings.buttons.previousSlide }}
      </BackButton>
      <ForwardButton v-if="nextAction"
        type="button"
        @click="maybeContinue"
        class="forwardButton"
        :disabled="!isCurrentSlide || !mayContinue"
        data-testing-target="submitOrNextButton"
      >
        {{ localeStrings.buttons[nextAction] }}
      </ForwardButton>
    </div>
  </form>
</template>

<script>
import strings from '../../data/strings.json'

import BackButton from './BackButton.vue'
import ForwardButton from './ForwardButton.vue'

export default {
  inject: ['locale', 'previousSlide', 'nextSlide', 'submitLead'],
  components: {
    BackButton,
    ForwardButton,
  },
  props: {
    isCurrentSlide: Boolean,
    isStartingSlide: Boolean,
    mayContinue: Boolean,
    title: String,
    nextAction: String,
  },
  methods: {
    maybeContinue() {
      if (this.mayContinue) {
        switch (this.nextAction) {
        case 'nextSlide':
          this.nextSlide()
          break;
        case 'submitLead':
          this.submitLead()
          break;
        }
      }
    },
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    },
  },
}
</script>

<style scoped>
.Slide {
  margin: 0 auto;
  width: 100%;
  max-width: 42rem;
}
.title {
  font-weight: 600;
  font-size: var(--font-size-7);
}
.body, .buttonRow {
  margin-top: var(--spacing-9);
}
.buttonRow {
  display: flex;
  column-gap: var(--spacing-4);
}
</style>
